import React from 'react'
import style from './articles.style'

const AmoCrmGa = ({ classes }) => {
  const code1 = `ga(function(tracker) { var cid = tracker.get('clientId') })`
  const code2 = `
  function parseCookie() {
    if (!isset($_COOKIE['_ga'])) {
        return gaGenUUID();
    } else {
        list($version, $domainDepth, $cidPart1, $cidPart2) = split('[\.]', $_COOKIE["_ga"], 4);
        return "$cidPart1.$cidPart2";
    }
  } 
  `
  const code3 = `
  function parseCid()
  {
    let cookieMatch = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)')
    let cookieRaw = (cookieMatch) ? decodeURIComponent(cookieMatch[1]) : null
    if (cookieRaw) {
      cookieMatch = cookieRaw.match(/(\d+\.\d+)$/)
    }

    return cookieMatch ? cookieMatch[1] : null
  }
  `
  const code4 = `
  function() {
    try {
      let cookieParts = {{ga cookie}}.split(".")
      return cookieParts[2] + "." + cookieParts[3]
    } catch (error) {
      return null
    }
   }   
  `

  return (
    <article className={classes.article}>
      <h2>Получение Google Client ID</h2>
      <p>Для интеграции CRM и Google Analytics, нужен ClientID (cid) клиента</p>
      <p>
        ClientID — это уникальный идентификатор, который отправляется в Google Analytics вместе с каждым обращением с сайта 
        и позволяет связать эти обращения с одним пользователем. 
        <br/>
        ClientID выступает ключом в записи всех данных о посещениях сайта.
        Для того, чтобы передавать какие-то данные в Google Analytics из CRM, и чтобы эти данные были связаны с посещениями пользователя, нужно знать этот ключ. 
      </p>
      <p>
        ClientID хранится в cookies, и поэтому определяет уникальность пользователя только в рамках этого конкретного браузера. 
        Если пользователь почистит cookies, зайдет под инкогнито, с другого браузера, с телефона, то для Google Analytics он станет еще одним пользователем.
      </p>
      <p>Ниже приведем примеры кода для получения ClientID:</p>
      <code className={classes.code}>{code1}</code>
      <code className={classes.code}>{code2}</code>
      <code className={classes.code}>{code3}</code>
      <code className={classes.code}>{code4}</code>
    </article>
  )
}

export default style(AmoCrmGa)
